import { ReactElement, useEffect } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import useTypedDispatch from '../../../common/useTypedDispatch';
import { Layout } from '../../../design-system/layout/Layout';
import { GnbMenuId } from '../../../domain/menu/constant';
import { selectGnbMenu } from '../../../domain/menu/util/MenuSlice';
import { ShortcutListContainer } from '../../../domain/shortcut/list/container/ShortcutListContainer';
import { CommonMobileHeaderType } from '../../../header/constants';
import { ReactQueryFetcher } from '../../../reactQuery/ReactQueryFetcher';
import { useShortcutListQuery } from '../../../wrapper/shortcutWrapper';

// TODO: @root ["요일연재" 롤백] 메뉴 추가되면 해당 페이지를 제거하자.
function ShortcutListMain() {
  const dispatch = useTypedDispatch();
  useEffect(() => {
    dispatch(selectGnbMenu(GnbMenuId.Shortcut));
  }, [dispatch]);
  return <>
      <ReactQueryFetcher reactQuery={useShortcutListQuery} options={{
      gcTime: Infinity
    }}>
        {data => <ShortcutListContainer data={data} />}
      </ReactQueryFetcher>
      <TrackPageViewContainer trackObj={{
      shouldSendUsagePage: true,
      shouldSendUsageScroll: true,
      section: '바로가기',
      page: '바로가기',
      actionType: 'Pageview',
      actionName: '바로가기_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </>;
}
ShortcutListMain.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('common_tab_direct')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowGnb: true,
    headerType: CommonMobileHeaderType.MainAndSub
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default ShortcutListMain;